export default function concatCx(a: string, b?: string) {
  // a is the default class of component
  if (!b) return a;
  return (a + " " + b).trim();
}
